import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import LoadScript from 'vue-plugin-load-script'
import VueLottiePlayer from 'vue-lottie-player'
import dayjs from './plugins/dayjs'
import _ from 'lodash'

Vue.use(LoadScript)
Vue.use(VueLottiePlayer)
Vue.config.productionTip = false
Vue.prototype.$dayjs = dayjs
Vue.prototype.$_ = _

if (process.env.NODE_ENV === 'prod') {
  Vue.config.devtools = false
  Vue.config.silent = true
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})
